// LoadingContext.tsx
import { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import LoadingScreen from './LoadingComponent';
import { CustomLoading } from './Loading';

interface LoadingContextType {
  loading: boolean;
  step?: string;
  subStep?: string;

  toggleLoading: (state: boolean) => void;
  changeStep: (text: string) => void;
  changeSubStep: (text: string) => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState<string | undefined>('Reticulating Splines');
  const [subStep, setSubStep] = useState<string | undefined>('Initializing Crystal Ball');

  const toggleLoading = (state: boolean) => setLoading(state);
  const changeStep = (text: string) => setStep(text);
  const changeSubStep = (text: string) => setSubStep(text);

  useEffect(() => {
    if (!loading) {
      setStep(undefined);
      setSubStep(undefined);
    }
  }, [loading]);

  return (
    <LoadingContext.Provider value={{ loading, toggleLoading, step, subStep, changeStep, changeSubStep }}>
      <CustomLoading />
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = (): LoadingContextType => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};
